module.exports = __webpack_public_path__ + "img/1900_YR_2022_Phone.a2b0d422.png";